var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10008 30.8167V25.9501C9.10008 24.3334 10.3667 22.8834 12.1667 22.8834C13.7834 22.8834 15.2334 24.1501 15.2334 25.9501V30.6334C15.2334 33.8834 12.5334 36.5834 9.28341 36.5834C6.03341 36.5834 3.33341 33.8667 3.33341 30.6334V20.3667C3.15008 11.0001 10.5501 3.41675 19.9167 3.41675C29.2834 3.41675 36.6667 11.0001 36.6667 20.1834V30.4501C36.6667 33.7001 33.9667 36.4001 30.7167 36.4001C27.4667 36.4001 24.7667 33.7001 24.7667 30.4501V25.7667C24.7667 24.1501 26.0334 22.7001 27.8334 22.7001C29.4501 22.7001 30.9001 23.9667 30.9001 25.7667V30.8167",
    stroke: "#494C50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.93cc6a849610dd68764eb94150a380c5.svg";
export { ForwardRef as ReactComponent };